/**
 * Barangay centroid coordinates for the BEST migration service area.
 *
 * Cities: Pasig, Mandaluyong, Marikina, San Juan
 *
 * Coordinates are approximate centroids (lat, lng) sourced from
 * publicly available geographic data. They are used for map
 * visualization and are accurate enough for barangay-level display.
 */

// Map center for the 4-city service area
export const SERVICE_AREA_CENTER = [14.575, 121.06];
export const SERVICE_AREA_ZOOM = 13;

// City-level centroids for fallback
export const CITY_CENTERS = {
  PASIG: [14.5764, 121.0851],
  MANDALUYONG: [14.5794, 121.0359],
  MARIKINA: [14.6507, 121.1029],
  "SAN JUAN": [14.6019, 121.0355],
};

/**
 * Barangay centroids keyed by "MUNICIPALITY|BARANGAY" (uppercase).
 * Each entry: [latitude, longitude]
 */
const BARANGAY_COORDS = {
  // ============================================================
  // PASIG
  // ============================================================
  "PASIG|BAGONG ILOG": [14.5657, 121.0727],
  "PASIG|BAGONG KATIPUNAN": [14.5631, 121.0802],
  "PASIG|BAMBANG": [14.5719, 121.0788],
  "PASIG|BUTING": [14.5699, 121.0746],
  "PASIG|CANIOGAN": [14.5752, 121.0712],
  "PASIG|DELA PAZ": [14.5781, 121.0763],
  "PASIG|KALAWAAN": [14.5685, 121.0825],
  "PASIG|KAPASIGAN": [14.5723, 121.0713],
  "PASIG|KAPITOLYO": [14.5718, 121.0580],
  "PASIG|KATIPUNAN": [14.5630, 121.0832],
  "PASIG|MALINAO": [14.5709, 121.0727],
  "PASIG|MANGGAHAN": [14.5794, 121.1012],
  "PASIG|MAYBUNGA": [14.5680, 121.0658],
  "PASIG|NAPICO": [14.5558, 121.0703],
  "PASIG|ORANBO": [14.5742, 121.0592],
  "PASIG|PALATIW": [14.5682, 121.0596],
  "PASIG|PINAGBUHATAN": [14.5812, 121.0885],
  "PASIG|PINEDA": [14.5722, 121.0640],
  "PASIG|ROSARIO": [14.5660, 121.0730],
  "PASIG|SAGAD": [14.5740, 121.0870],
  "PASIG|SAN ANTONIO": [14.5698, 121.0602],
  "PASIG|SAN JOAQUIN": [14.5650, 121.0770],
  "PASIG|SAN JOSE": [14.5715, 121.0770],
  "PASIG|SAN MIGUEL": [14.5720, 121.0694],
  "PASIG|SAN NICOLAS": [14.5706, 121.0755],
  "PASIG|SANTA CRUZ": [14.5721, 121.0802],
  "PASIG|STA CRUZ": [14.5721, 121.0802],
  "PASIG|STA LUCIA": [14.5787, 121.0825],
  "PASIG|SANTA LUCIA": [14.5787, 121.0825],
  "PASIG|SANTOLAN": [14.5830, 121.0870],
  "PASIG|STO TOMAS": [14.5680, 121.0792],
  "PASIG|SANTO TOMAS": [14.5680, 121.0792],
  "PASIG|SANTA ROSA": [14.5735, 121.0715],
  "PASIG|SUMILANG": [14.5634, 121.0762],
  "PASIG|UGONG": [14.5620, 121.0656],
  "PASIG|UGONG NORTE": [14.5750, 121.0670],

  // ============================================================
  // MANDALUYONG
  // ============================================================
  "MANDALUYONG|ADDITION HILLS": [14.5825, 121.0330],
  "MANDALUYONG|BAGONG SILANG": [14.5773, 121.0380],
  "MANDALUYONG|BARANGKA DRIVE": [14.5810, 121.0400],
  "MANDALUYONG|BARANGKA IBABA": [14.5780, 121.0384],
  "MANDALUYONG|BARANGKA ILAYA": [14.5798, 121.0408],
  "MANDALUYONG|BARANGKA ITAAS": [14.5820, 121.0415],
  "MANDALUYONG|BUAYANG BATO": [14.5740, 121.0410],
  "MANDALUYONG|BUROL": [14.5758, 121.0345],
  "MANDALUYONG|DAANG BAKAL": [14.5762, 121.0355],
  "MANDALUYONG|HAGDANG BATO": [14.5745, 121.0335],
  "MANDALUYONG|HAGDANG BATO ITAAS": [14.5755, 121.0340],
  "MANDALUYONG|HAGDANG BATO LIBIS": [14.5735, 121.0330],
  "MANDALUYONG|HARAPIN ANG BUKAS": [14.5790, 121.0310],
  "MANDALUYONG|HIGHWAY HILLS": [14.5815, 121.0425],
  "MANDALUYONG|HULO": [14.5765, 121.0420],
  "MANDALUYONG|MABINI J RIZAL": [14.5730, 121.0360],
  "MANDALUYONG|MALAMIG": [14.5805, 121.0363],
  "MANDALUYONG|MAUWAY": [14.5775, 121.0325],
  "MANDALUYONG|NAMAYAN": [14.5750, 121.0350],
  "MANDALUYONG|NEW ZANIGA": [14.5725, 121.0465],
  "MANDALUYONG|OLD ZANIGA": [14.5735, 121.0445],
  "MANDALUYONG|PAG ASA": [14.5793, 121.0350],
  "MANDALUYONG|PLAINVIEW": [14.5835, 121.0375],
  "MANDALUYONG|PLEASANT HILLS": [14.5843, 121.0360],
  "MANDALUYONG|POBLACION": [14.5785, 121.0365],
  "MANDALUYONG|SAN JOSE": [14.5770, 121.0395],
  "MANDALUYONG|VERGARA": [14.5755, 121.0445],
  "MANDALUYONG|WACK WACK": [14.5860, 121.0430],
  "MANDALUYONG|WACK WACK GREENHILLS": [14.5855, 121.0450],
  "MANDALUYONG|GREENHILLS": [14.5865, 121.0470],

  // ============================================================
  // MARIKINA
  // ============================================================
  "MARIKINA|BARANGKA": [14.6310, 121.0960],
  "MARIKINA|CALUMPANG": [14.6340, 121.1020],
  "MARIKINA|CONCEPCION UNO": [14.6380, 121.0990],
  "MARIKINA|CONCEPCION 2": [14.6420, 121.0990],
  "MARIKINA|CONCEPCION DOS": [14.6420, 121.0990],
  "MARIKINA|FORTUNE": [14.6570, 121.1140],
  "MARIKINA|INDUSTRIAL VALLEY": [14.6460, 121.1030],
  "MARIKINA|JESUS DELA PENA": [14.6280, 121.0960],
  "MARIKINA|MALANDAY": [14.6350, 121.0940],
  "MARIKINA|MARIKINA HEIGHTS": [14.6500, 121.1100],
  "MARIKINA|NANGKA": [14.6540, 121.1060],
  "MARIKINA|PARANG": [14.6430, 121.1050],
  "MARIKINA|PARAISO": [14.6400, 121.1050],
  "MARIKINA|SAN ROQUE": [14.6330, 121.0960],
  "MARIKINA|STA ELENA": [14.6490, 121.1110],
  "MARIKINA|SANTA ELENA": [14.6490, 121.1110],
  "MARIKINA|STO NINO": [14.6370, 121.0960],
  "MARIKINA|SANTO NINO": [14.6370, 121.0960],
  "MARIKINA|TANONG": [14.6300, 121.0930],
  "MARIKINA|TUMANA": [14.6350, 121.1000],

  // ============================================================
  // SAN JUAN
  // ============================================================
  "SAN JUAN|ADDITION HILLS": [14.5960, 121.0340],
  "SAN JUAN|BALONG BATO": [14.6030, 121.0320],
  "SAN JUAN|BATIS": [14.6010, 121.0350],
  "SAN JUAN|CORAZON DE JESUS": [14.6060, 121.0360],
  "SAN JUAN|ERMITANO": [14.5995, 121.0340],
  "SAN JUAN|GREENHILLS": [14.6005, 121.0430],
  "SAN JUAN|ISABELITA": [14.6040, 121.0330],
  "SAN JUAN|KABAYANAN": [14.6020, 121.0340],
  "SAN JUAN|LITTLE BAGUIO": [14.6000, 121.0370],
  "SAN JUAN|MAYTUNAS": [14.5980, 121.0320],
  "SAN JUAN|ONSE": [14.6050, 121.0340],
  "SAN JUAN|PASADENA": [14.5985, 121.0310],
  "SAN JUAN|PEDRO CRUZ": [14.6020, 121.0360],
  "SAN JUAN|PROGRESO": [14.6065, 121.0380],
  "SAN JUAN|RIVERA": [14.5990, 121.0325],
  "SAN JUAN|SALAPAN": [14.6045, 121.0375],
  "SAN JUAN|SAN JOSE": [14.5978, 121.0310],
  "SAN JUAN|SAN PERFECTO": [14.6035, 121.0370],
  "SAN JUAN|STA LUCIA": [14.5990, 121.0355],
  "SAN JUAN|SANTA LUCIA": [14.5990, 121.0355],
  "SAN JUAN|TIBAGAN": [14.6055, 121.0400],
  "SAN JUAN|WEST CRAME": [14.6000, 121.0390],
};

/**
 * Canonical reference list of official barangays per municipality.
 * Used for form dropdowns so all barangays are always available,
 * even if no records exist yet in the database.
 *
 * Sources: Philippine Standard Geographic Code (PSGC) / PSA;
 *          Wikipedia articles citing PSGC data.
 */
export const REFERENCE_BARANGAYS = {
  PASIG: [
    "BAGONG ILOG",
    "BAGONG KATIPUNAN",
    "BAMBANG",
    "BUTING",
    "CANIOGAN",
    "DELA PAZ",
    "KALAWAAN",
    "KAPASIGAN",
    "KAPITOLYO",
    "MALINAO",
    "MANGGAHAN",
    "MAYBUNGA",
    "ORANBO",
    "PALATIW",
    "PINAGBUHATAN",
    "PINEDA",
    "ROSARIO",
    "SAGAD",
    "SAN ANTONIO",
    "SAN JOAQUIN",
    "SAN JOSE",
    "SAN MIGUEL",
    "SAN NICOLAS",
    "SANTA CRUZ",
    "SANTA LUCIA",
    "SANTA ROSA",
    "SANTO TOMAS",
    "SANTOLAN",
    "SUMILANG",
    "UGONG",
  ],
  MANDALUYONG: [
    "ADDITION HILLS",
    "BAGONG SILANG",
    "BARANGKA DRIVE",
    "BARANGKA IBABA",
    "BARANGKA ILAYA",
    "BARANGKA ITAAS",
    "BUAYANG BATO",
    "BUROL",
    "DAANG BAKAL",
    "HAGDANG BATO ITAAS",
    "HAGDANG BATO LIBIS",
    "HARAPIN ANG BUKAS",
    "HIGHWAY HILLS",
    "HULO",
    "MABINI J RIZAL",
    "MALAMIG",
    "MAUWAY",
    "NAMAYAN",
    "NEW ZANIGA",
    "OLD ZANIGA",
    "PAG ASA",
    "PLAINVIEW",
    "PLEASANT HILLS",
    "POBLACION",
    "SAN JOSE",
    "VERGARA",
    "WACK WACK GREENHILLS",
  ],
  MARIKINA: [
    "BARANGKA",
    "CALUMPANG",
    "CONCEPCION UNO",
    "CONCEPCION DOS",
    "FORTUNE",
    "INDUSTRIAL VALLEY",
    "JESUS DELA PENA",
    "MALANDAY",
    "MARIKINA HEIGHTS",
    "NANGKA",
    "PARANG",
    "SAN ROQUE",
    "STA ELENA",
    "STO NINO",
    "TANONG",
    "TUMANA",
  ],
  "SAN JUAN": [
    "ADDITION HILLS",
    "BALONG BATO",
    "BATIS",
    "CORAZON DE JESUS",
    "ERMITANO",
    "GREENHILLS",
    "ISABELITA",
    "KABAYANAN",
    "LITTLE BAGUIO",
    "MAYTUNAS",
    "ONSE",
    "PASADENA",
    "PEDRO CRUZ",
    "PROGRESO",
    "RIVERA",
    "SALAPAN",
    "SAN JOSE",
    "SAN PERFECTO",
    "STA LUCIA",
    "TIBAGAN",
    "WEST CRAME",
  ],
};

/**
 * Look up the centroid for a given municipality + barangay.
 * Falls back to city center if barangay not found.
 * Returns null if municipality is also unknown.
 */
export function getBarangayCoords(municipality, barangay) {
  if (!municipality) return null;
  const muni = municipality.toUpperCase().trim();
  const brgy = (barangay || "").toUpperCase().trim();
  const key = `${muni}|${brgy}`;
  if (BARANGAY_COORDS[key]) return BARANGAY_COORDS[key];
  // Fallback to city center
  if (CITY_CENTERS[muni]) return CITY_CENTERS[muni];
  return null;
}

export default BARANGAY_COORDS;
